(function (app) {

    app.provider("userRegistrationApi",
        [
            function () {
                this.$get = [
                    "portalApiGateway", function (complianceHubApiGateway) {
                        var service = {};

                        service.getUserRegistration = function (userRegistrationId) {
                            return complianceHubApiGateway.get("/UserRegistrations/" + userRegistrationId);
                        };

                        service.getUserRegistrationByToken = function (token) {
                            return complianceHubApiGateway.get("/UserRegistrations/Token/" + token);
                        };

                        service.getAllIncompleteUserRegistrations = function () {
                            return complianceHubApiGateway.getArray("/UserRegistrations/All");
                        };

                        service.completeUserRegistration = function (userRegistration) {
                            return complianceHubApiGateway.put("/UserRegistrations/" + userRegistration.Id, userRegistration);
                        };

                        return service;
                    }
                ];
            }
        ]);
})(window.app); // jshint ignore:line